import * as React from "react";
import { logger } from "bernie-core";
import {
  BlossomComponentFactory,
  BlossomComponentFactoryProps,
} from "components/flexFramework/domain/BlossomComponentFactory";
import { AffinityRegionProps } from "./typings";
import { WrapperFactory } from "./WrapperFactory";

const AffinityRegionComponent = (props: AffinityRegionProps) => {
  const blossomComponent = BlossomComponentFactory.get(props as BlossomComponentFactoryProps);
  const { context, flexComponent } = props;

  if (!flexComponent || !flexComponent.model || !blossomComponent) {
    return null;
  }

  const view = React.useMemo(() => blossomComponent.getView(), [blossomComponent]);
  const Wrapper = React.useMemo(() => WrapperFactory.get(view), [view]);
  const children = blossomComponent.renderChildren(props.logger, props.l10n, context);

  return <Wrapper>{children}</Wrapper>;
};

export const AffinityRegion = logger("AffinityRegion")(AffinityRegionComponent);

export default AffinityRegion;
